import { InjectionToken } from '@angular/core';

export type DigitalAccessPortal = {
  environment: string;
  applicationId: string;
  url: string;
  organizationId?: string;
};

export type ExcelExports = {
  exportSimulationData: string;
};

export type CalculationSettings = {
  enableDebugFeatures: string;
};

export type AppConfig = {
  digitalAccessPortal: DigitalAccessPortal;
  useConfigFile: boolean;
  pricingToolLink: string;
  jiraLink: string;
  excelExports: ExcelExports;
  calculationSettings: CalculationSettings;
  clarityProjectId: string;
};

export const APP_CONFIG: InjectionToken<AppConfig> =
  new InjectionToken<AppConfig>('Application Config');
